module.exports = __webpack_public_path__ + "img/2_1_thirdparty.2ffdb57c.gif";